import { AuthService } from '../auth/auth.service';

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function appInitializer(_authService: AuthService) {
  return () =>
    new Promise<void>((resolve) => {
      if (!navigator?.onLine) {
        return resolve();
      }

      if (!_authService.accessToken) {
        return resolve();
      }

      // attempt to get user on app start up to auto authenticate
      _authService.getMe().subscribe().add(resolve);
    });
}
